import { render, staticRenderFns } from "./repa.vue?vue&type=template&id=20fcc5fe&scoped=true&"
import script from "./repa.vue?vue&type=script&lang=js&"
export * from "./repa.vue?vue&type=script&lang=js&"
import style0 from "./repa.vue?vue&type=style&index=0&id=20fcc5fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fcc5fe",
  null
  
)

export default component.exports